import { useEffect, useState } from 'react';
import DeleteIcon from '../../../assets/Modals/DeleteIcon';
import Denounce from '../../../assets/Modals/Denounce';
import StarIcon from '../../../assets/Modals/StartIcon/StarIcon';
import { useAuth } from '../../../contexts/auth';
import { api } from '../../../services/api';
import { Button, Container } from './styles';

type PostModalProps = {
  commentId: string;
  onAction: any;
  open: boolean;
  authorUsername: string;
  publicationUsername: string;
  scrollY: number;
  feedType: string;
};

export default function CommentsModal({ commentId, onAction, open, authorUsername, publicationUsername, scrollY, feedType }: PostModalProps) {
  const { user } = useAuth();
  const [isOwner, setIsOwner] = useState<boolean>(user?.username === authorUsername);
  const [isPublicationOwner, setIsPublicationOwner] = useState<boolean>(user?.username === publicationUsername);
  useEffect(() => {
    if (user && user.username) {
      setIsOwner(user?.username === authorUsername)
    }
    if (user && user.username) {
      setIsPublicationOwner(user?.username === publicationUsername)
    }
  }, [user?.username, authorUsername, publicationUsername, open])

  const handleDeleteComment = () => {
    api.delete(`/comments/${commentId}`).then(response => {
      // console.log(response);
    });
  };

  return (
    <>
      {open && (
        <Container style={{ marginTop: scrollY, left: feedType === 'snipz' ? '56vw' : undefined, maxWidth: feedType === 'snipz' ? '130px' : undefined }}>
          {isPublicationOwner ? (
            <>
              {!isOwner && (
                <Button delete={true}>
                  <Denounce />
                  Denunciar
                </Button>
              )}
              <Button delete={true} onClick={handleDeleteComment}>
                <DeleteIcon />
                Excluir
              </Button>
              <Button delete={false}>
                <StarIcon />
                Destacar
              </Button>
            </>
          ) : (
            <>
              {isOwner && (
                <Button delete={true} onClick={handleDeleteComment}>
                  <DeleteIcon />
                  Excluir
                </Button>
              )}
              {!isOwner && (
                <Button delete={true}>
                  <Denounce />
                  Denunciar
                </Button>
              )}
            </>
          )}
        </Container>
      )}
    </>
  );
}